<div class='container-root'>
  <mat-sidenav-container class="smrts-sidenav-container">
    <mat-sidenav #drawer [fixedInViewport]="true" [attr.role]="'dialog'"
                 [mode]="'over'" [(opened)]="drawerOpened" [autoFocus]="false"
                 class="smrts-background-color">
      <smrts-menu [menuDrawer]="drawer">
      </smrts-menu>
    </mat-sidenav>
    <mat-sidenav-content class="smrts-background-color">
      <div class="content-body">
        <div class="content-outlet smrts-background-color">
          <router-outlet></router-outlet>
        </div>
      </div>
    </mat-sidenav-content>
  </mat-sidenav-container>
</div>